module.exports = __webpack_public_path__ + "img/g3_lvyexianzong.f5168da4.jpg";